(() => {
  let cancelActive = null;
  const bound = new WeakSet();
  window.JmCollectionPagination = {
    cancel() {
      cancelActive?.();
      cancelActive = null;
    },
    bind(afterAppend) {
      const grid = document.querySelector('.collection__grid-loadmore');
      const container = grid?.closest('#CollectionProductContainer');
      const button = container?.querySelector('.collection__btn-loadmore');
      if (!grid || !button || bound.has(button)) return;
      bound.add(button);
      let controller = null;
      const error = container.querySelector('.jm-collection-load-error');
      button.addEventListener('click', async event => {
        const nextURL = grid.dataset.nextUrl;
        if (controller || !nextURL || !grid.isConnected) return;
        const request = new AbortController();
        controller = request;
        const reset = () => {
          button.disabled = false;
          button.classList.remove('loading');
          button.removeAttribute('aria-busy');
          grid.removeAttribute('aria-busy');
        };
        const cancel = () => {
          request.abort();
          reset();
        };
        cancelActive = cancel;
        button.disabled = true;
        button.classList.add('loading');
        button.setAttribute('aria-busy', 'true');
        grid.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;
        try {
          const response = await fetch(nextURL, { signal: request.signal });
          if (!response.ok) throw new Error('Collection page failed');
          const html = await response.text();
          if (request.signal.aborted || !grid.isConnected) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incoming = parsed.getElementById(grid.id);
          if (!incoming || incoming.dataset.id !== grid.dataset.id) throw new Error('Collection grid missing');
          const items = [...incoming.children];
          if (!items.length) throw new Error('Collection page empty');
          grid.append(...items);
          const next = incoming.dataset.nextUrl;
          if (next) grid.dataset.nextUrl = next;
          else delete grid.dataset.nextUrl;
          const count = grid.querySelectorAll('.product--item').length;
          container.querySelectorAll('.pagination__count .count').forEach(node => { node.textContent = count; });
          document.querySelectorAll('.pagination__count-top .count').forEach(node => { node.textContent = count; });
          const bar = container.querySelector('.pagination__bar');
          const progress = bar?.querySelector('.progress');
          const total = Number(bar?.dataset.max);
          if (progress && total > 0) progress.style.width = `${Math.min(100, count / total * 100)}%`;
          if (event.detail === 0 || (!next && document.activeElement === button)) {
            items[0].querySelector('a[href], button')?.focus();
          }
          if (!next) button.remove();
          afterAppend?.();
        } catch (failure) {
          if (!request.signal.aborted && grid.isConnected && error) error.hidden = false;
        } finally {
          if (controller === request) {
            controller = null;
            if (cancelActive === cancel) cancelActive = null;
            reset();
          }
        }
      });
    }
  };
})();
